// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumb_wrapper__3FmW1","item":"Breadcrumb_item__X73Du"};